import { Link } from '@tanstack/react-router';

interface PolicySummaryProps {
  totalActiveItems?: number;
  totalInActiveItems?: number;
  totalItems?: number;
  hasDirectLink?: boolean;
}

/**
 * The PolicySummary component provides a table with high-level
 * numbers around policies issued
 *
 * @param {object} props
 *   @param {number} props.totalActiveItems - Total active policies
 *   @param {number} props.totalInActiveItems - Total inactive policies
 *   @param {number} props.totalItems - Total policies
 *   @param {number} props.hasDirectLink - Add a link after "Total items" to the policy navigator
 * @returns {JSX.Element}
 **/
const PolicySummary: React.FC<PolicySummaryProps> = ({
  totalActiveItems,
  totalInActiveItems,
  totalItems,
  hasDirectLink,
}) => (
  <div data-testid="PolicySummary">
    <dl className="grid grid-cols-1 py-4 text-ingle-light-purple sm:grid-cols-3">
      <div className="flex flex-col border-l border-y border-gray-300 py-6 px-7 rounded-tl-md rounded-bl-md">
        <dt className="mb-2 text-5xl font-bold">{totalActiveItems}</dt>
        <dd className="text-black font-semibold">Active Policies</dd>
      </div>
      <div className="flex flex-col border border-gray-300 py-6 px-7">
        <dt className="mb-2 text-5xl font-bold">{totalInActiveItems}</dt>
        <dd className="text-black font-semibold">Inactive Policies</dd>
      </div>
      <div className="flex flex-col border-r border-y border-gray-300 py-6 px-7 rounded-tr-md rounded-br-md">
        <dt className="mb-2 text-5xl font-bold">{totalItems}</dt>
        <dd className="text-black font-semibold">
          <div>Total Policies</div>
          {hasDirectLink ? (
            <Link
              to="/policies"
              className="text-ingle-light-purple hover:underline"
            >
              See more with Policy Navigator
            </Link>
          ) : null}
        </dd>
      </div>
    </dl>
  </div>
);

export default PolicySummary;
